<template>
  <div v-if="contests.config" id="top">
    <loading v-if="loadingState" />
    <div class="container">
      <div class="row mt-5 pt-5">
        <div v-if="contests.config" class="col-12 center">
          <img :src="contests.config.LOGO_INTERNO" class="img img-fluid" />
        </div>
      </div>
      <nav class="">
        <div class="nav nav-tabs mt-3" id="nav-tab" role="tablist">
          <a
            v-if="contest"
            class="nav-item nav-link active"
            :style="'background-color:' + contests.config.COLORE_PRINCIPALE"
            id="nav-home-tab"
            data-toggle="tab"
            href="#nav-home"
            role="tab"
            aria-controls="nav-home"
            aria-selected="true"
            v-on:click="changeView(1)"
            >Promozione</a
          >
          <a
            v-else
            class="nav-item nav-link active"
            id="nav-home-tab"
            data-toggle="tab"
            href="#nav-home"
            role="tab"
            aria-controls="nav-home"
            aria-selected="true"
            v-on:click="changeView(1)"
            >Promozione</a
          >
          <a
            v-if="info"
            class="nav-item nav-link"
            :style="'background-color:' + contests.config.COLORE_PRINCIPALE"
            id="nav-profile-tab"
            data-toggle="tab"
            href="#nav-profile"
            role="tab"
            aria-controls="nav-profile"
            aria-selected="false"
            v-on:click="changeView(2)"
            >dettaglio caricamenti</a
          >
          <a
            v-else
            class="nav-item nav-link"
            id="nav-profile-tab"
            data-toggle="tab"
            href="#nav-profile"
            role="tab"
            aria-controls="nav-profile"
            aria-selected="false"
            v-on:click="changeView(2)"
            >dettaglio caricamenti</a
          >
          <a
            v-if="premi"
            class="nav-item nav-link"
            :style="'background-color:' + contests.config.COLORE_PRINCIPALE"
            id="nav-profile-tab"
            data-toggle="tab"
            href="#nav-profile"
            role="tab"
            aria-controls="nav-profile"
            aria-selected="false"
            v-on:click="changeView(3)"
            >catalogo premi</a
          >
          <a
            v-else
            class="nav-item nav-link"
            id="nav-profile-tab"
            data-toggle="tab"
            href="#nav-profile"
            role="tab"
            aria-controls="nav-profile"
            aria-selected="false"
            v-on:click="changeView(3)"
            >catalogo premi</a
          >
        </div>
      </nav>
    </div>
    <div
      v-if="!info && contest && !premi"
      class="container padd pt-2 pb-5"
      id="nav-home"
    >
      <div class="row justify-content-center pb-5 pt-3 back-white">
        <div
          v-on:click="toContest()"
          class="col-md-9 mt-3 center"
          :class="{ 'back-color-3': empty }"
        >
          <router-link
            v-if="
              my_registration_in_promo <= maxRegistration &&
              moment(now) <= moment(end_, 'YYYY-MM-DD')
            "
            :to="{
              name: 'Play',
              params: { id: id, piva: piva, cod: cod_client },
            }"
          >
            <h4
              :class="{
                'back-color-2 white':
                  my_registration_in_promo > maxRegistration,
                'back-white color uppercase ':
                  my_registration_in_promo <= maxRegistration && !empty,
                'back-color-3 white uppercase':
                  my_registration_in_promo < maxRegistration && empty,
              }"
              class="center padd"
            >
              {{ title }}
            </h4>
            <small v-if="!empty" class="color underline"
              >Premi qui per andare direttamente al caricamento dello
              scontrino</small
            >
          </router-link>
        </div>
        <div class="col-md-12">
          <router-link
            v-if="
              my_registration_in_promo < maxRegistration &&
              !empty &&
              moment(now) <= moment(end_, 'YYYY-MM-DD')
            "
            :to="{
              name: 'Play',
              params: { id: id, piva: piva, cod: cod_client },
            }"
          >
            <countdown :time="countdown">
              <template slot-scope="props">
                <h5 v-if="vw <= 770 && !empty" class="mt-1 center activeTxt">
                  Ti rimangono:
                </h5>
                <h5 v-if="vw <= 770 && empty" class="mt-1 center activeTxt">
                  Mancano:
                </h5>
                <div
                  class="row center justify-content-center pb-2 pt-3 text-right"
                >
                  <h5 v-if="vw > 770 && !empty" class="mt-3 activeTxt">
                    Ti rimangono:
                  </h5>
                  <h5 v-if="vw > 770 && empty" class="mt-3 activeTxt">
                    Mancano:
                  </h5>
                  <div
                    class="countdown ml-2 mr-2 text-center relative"
                    :style="'background: ' + contests.config.COLORE_SCURO"
                  >
                    <div class="Bold timeVal">{{ props.days }}</div>
                    <p v-if="props.days == 1" class="classic Regular mt-1 mb-0">
                      giorno
                    </p>
                    <p v-else class="classic Regular mt-1 mb-0">giorni</p>
                  </div>
                  <div
                    class="countdown ml-2 mr-2 text-center relative"
                    :style="'background: ' + contests.config.COLORE_SCURO"
                  >
                    <div class="Bold timeVal">{{ props.hours }}</div>
                    <p
                      v-if="props.hours == 1"
                      class="classic darkBlue Regular mt-1 mb-0"
                    >
                      ora
                    </p>
                    <p v-else class="classic Regular mt-1 mb-0">ore</p>
                  </div>
                  <div
                    class="countdown ml-2 mr-2 text-center relative"
                    :style="'background: ' + contests.config.COLORE_SCURO"
                  >
                    <div class="Bold timeVal">{{ props.minutes }}</div>
                    <p
                      v-if="props.minutes == 1"
                      class="classic Regular mt-1 mb-0"
                    >
                      minuto
                    </p>
                    <p v-else class="classic Regular mt-1 mb-0">minuti</p>
                  </div>
                  <div
                    class="countdown ml-2 mr-2 text-center relative"
                    :style="'background: ' + contests.config.COLORE_SCURO"
                  >
                    <div class="Bold timeVal">{{ props.seconds }}</div>
                    <p
                      v-if="props.seconds == 1"
                      class="classic Regular mt-1 mb-0"
                    >
                      secondo
                    </p>
                    <p v-else class="classic Regular mt-1 mb-0">secondi</p>
                  </div>
                  <h5 v-if="vw >= 770 && !empty" class="mt-1 activeTxt">
                    per registrare <br />uno scontrino
                  </h5>
                  <h5
                    v-if="vw >= 770 && empty"
                    class="mt-1 text-left activeTxt"
                  >
                    al termine<br />della promozione
                  </h5>
                </div>
                <h5 v-if="vw < 770 && !empty" class="mt-1 center activeTxt">
                  per registrare uno scontrino
                </h5>
                <h5 v-if="vw < 770 && empty" class="mt-1 center activeTxt">
                  al termine della promozione
                </h5>
              </template>
            </countdown>
          </router-link>
          <p class="center black Bold mr-lg-5 mb-md-5 mt-lg-0 mt-3">
            Validitá promozione: dal <b class="underline">{{ start }}</b> al
            <b class="underline">{{ end_rec }}<br /></b>con possibilità di
            caricare gli scontrini fino al <b>{{ end }}</b>
          </p>
        </div>
        <div v-if="empty" class="col-md-10 center">
          <p class="bordered-1 Black Bold h3 mt-3" v-if="finish">
            Promozione terminata
          </p>
          Validitá promozione: dal <b class="underline">{{ start }}</b> al
          <b class="underline">{{ end_rec }}<br /> </b> con possibilità di
          caricare gli scontrini fino al <b>{{ end }}</b>
        </div>
        <div
          v-if="contests.config"
          class="col-lg-4 col-md-4 pt-5 mt-lg-0 mt-md-4 center mb-3 mb-md-0"
        >
          <a
            v-if="!!contests.config.REGOLAMENTO"
            :href="contests.config.REGOLAMENTO"
            target="_blank"
            ><button
              class="
                center
                uppercase
                white
                bordered
                back-color-1
                btn btn-primary-4
                mb-2
              "
              :style="
                'background: ' +
                contests.config.COLORE_MEDIO_SCURO +
                '!important'
              "
            >
              Regolamento <img :src="doc" /></button
          ></a>
          <br /><a
            v-if="!!contests.config.FAQ"
            :href="contests.config.FAQ"
            target="_blank"
            ><button
              class="
                center
                uppercase
                back-color-1
                white
                bordered
                btn btn-primary-4
              "
              :style="
                'background: ' +
                contests.config.COLORE_MEDIO_SCURO +
                '!important'
              "
            >
              Faq <img :src="doc" /></button
          ></a>
        </div>
        <div v-if="!finish" class="col-md-4 col-8 text-left">
          <vue-gauge
            v-if="vw > 1000"
            :refid="'type-unique-id'"
            :options="{
              needleValue: my_registration_in_promo,
              chartWidth: [vw * 0.2],
              centralLabel: [''],
              arcColors: [
                '' + contests.config.COLORE_MEDIO_SCURO + '',
                '' + contests.config.COLORE_MEDIO_CHIARO + '',
                '' + contests.config.COLORE_SCURO + '',
              ],
              arcLabels: [55, 80, 100],
              arcDelimiters: [55, 80, 99],
              hasNeedle: [true],
              arcOverEffect: [true],
              needleColor: ['#f29daf'],
            }"
          ></vue-gauge>
          <vue-gauge
            v-if="vw > 600 && vw < 1000"
            :refid="'type-unique-id'"
            :options="{
              needleValue: my_registration_in_promo,
              chartWidth: [vw * 0.3],
              centralLabel: [''],
              arcColors: [
                '' + contests.config.COLORE_MEDIO_SCURO + '',
                '' + contests.config.COLORE_MEDIO_CHIARO + '',
                '' + contests.config.COLORE_SCURO + '',
              ],
              arcLabels: [55, 80, 100],
              arcDelimiters: [55, 80, 99],
              hasNeedle: [true],
              arcOverEffect: [true],
              needleColor: ['#f29daf'],
            }"
          ></vue-gauge>
          <vue-gauge
            v-if="vw < 600"
            :refid="'type-unique-id'"
            :options="{
              needleValue: my_registration_in_promo,
              chartWidth: [vw * 0.6],
              centralLabel: [''],
              arcColors: [
                '' + contests.config.COLORE_MEDIO_SCURO + '',
                '' + contests.config.COLORE_MEDIO_CHIARO + '',
                '' + contests.config.COLORE_SCURO + '',
              ],
              arcLabels: [55, 80, 100],
              arcDelimiters: [55, 80, 99],
              hasNeedle: [true],
              arcOverEffect: [true],
              needleColor: ['#f29daf'],
            }"
          ></vue-gauge>
          <div class="punti Bold h5 text-center">
            <b
              >{{ my_registration_in_promo }} punti ottenuti<br />
              su {{ my_registration_in_promo_done }} richiesti</b
            >
          </div>
        </div>
        <div v-if="!empty && !finish" class="col-lg-4 col-md-4 mt-5 pt-4">
          <!--<h5 class="uppercase Bold">Descrizione:</h5>
               <p class="customHowTo pull-left">{{contests.config.DESCRIZIONE}}</p>-->
          <p class="customHowTo pull-left">
            <img src="../../assets/images/soglie.png" class="img img-fluid" />
          </p>
        </div>
      </div>
      <div
        v-if="!empty && !finish"
        class="row justify-content-center pt-md-5"
        :class="{ 'back-white': !empty && contest && !info }"
      >
        <div v-if="contests.config.STEP_1" class="col-md-3">
          <div class="row">
            <div class="col-2">
              <b class="text-left step">1<br /></b>
            </div>
            <div class="col-10 mt-4 pt-1">
              <p class="pull-left customHowTo">{{ contests.config.STEP_1 }}</p>
            </div>
          </div>
        </div>
        <div v-if="contests.config.STEP_2" class="col-md-3">
          <div class="row">
            <div class="col-2">
              <b class="text-left step">2<br /></b>
            </div>
            <div class="col-10 mt-4 pt-1">
              <p class="pull-left customHowTo">{{ contests.config.STEP_2 }}</p>
            </div>
          </div>
        </div>
        <div v-if="contests.config.STEP_3" class="col-md-3">
          <div class="row">
            <div class="col-2">
              <b class="text-left step">3<br /></b>
            </div>
            <div class="col-10 mt-4 pt-1">
              <p class="pull-left customHowTo">{{ contests.config.STEP_3 }}</p>
            </div>
          </div>
        </div>
        <div v-if="contests.config.STEP_4" class="col-md-3">
          <div class="row">
            <div class="col-2">
              <b class="text-left step">4<br /></b>
            </div>
            <div class="col-10 mt-4 pt-1">
              <p class="pull-left customHowTo">{{ contests.config.STEP_4 }}</p>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="!empty && finish"
        class="row justify-content-center"
        :class="{ 'back-white': !empty && contest && !info }"
      >
        <div class="col-10">
          <img class="img-fluid img" :src="contests.config.IMMAGINE_HOME" />
        </div>
      </div>
      <div
        class="row pt-5 pb-5 back-white"
        :class="{
          'back-white justify-content-center': !empty && contest && !info,
        }"
      >
        <div
          v-if="
            !empty &&
            contest &&
            !info &&
            moment(now) <= moment(end_, 'YYYY-MM-DD')
          "
          class="col-lg-12 col-md-5 center mt-md-4 mt-5 pt-lg-0 pt-md-4"
        >
          <router-link
            v-if="my_registration_in_promo < maxRegistration"
            :to="{
              name: 'Play',
              params: { id: id, piva: piva, cod: cod_client },
            }"
            class="btn btn-primary"
            :style="
              'background: ' + contests.config.COLORE_SCURO + '!important'
            "
            >Registra uno scontrino</router-link
          >
          <p
            class="bordered-1 back-color white Medium h5"
            v-else
            :style="
              'background: ' + contests.config.COLORE_SCURO + '!important'
            "
          >
            Numero massimo di richieste di rimborso raggiunto
          </p>
        </div>
        <div
          v-if="!empty && contest && !info"
          class="center mt-md-4 mt-5 pt-lg-0 pt-md-4"
          :class="{
            'col-12': moment(now) >= moment(end, 'DD-MM-YYYY'),
            'col-lg-5 col-md-5':
              moment(now) <= moment(end_, 'YYYY-MM-DD'),
          }"
        >
          <p
            class="bordered-1 back-color black Bold uppercase"
            :style="
              'background: ' +
              contests.config.COLORE_SCURO +
              '!important;color: ' +
              contests.config.COLORE_CHIARO +
              '!important'
            "
            v-if="moment(now) < moment(start, 'YYYY-MM-DD HH:mm:ss')"
          >
            Promozione non ancora iniziata
          </p>
          <p
            class="bordered-1 back-color black Bold uppercase"
            :style="
              'background: ' +
              contests.config.COLORE_SCURO +
              '!important;color: ' +
              contests.config.COLORE_CHIARO +
              '!important'
            "
            v-if="moment(now) >= moment(end, 'DD-MM-YYYY')"
          >
            Promozione terminata
          </p>
        </div>
      </div>
    </div>
    <div v-else-if="info && !contest && !premi" id="nav-profile ">
      <div class="container mt-5 pb-5 mb-5 back-white">
        <div
          v-if="playContest != ''"
          class="row justify-content-center pl-3 pr-3"
        >
          <badger-accordion ref="activeAccordion">
            <badger-accordion-item @close="selectedPlay = {}">
              <template slot="header" class="center black">
                <div class="row justify-content-center mb-5 pb-5">
                  <div class="col-12 col-md-10 mt-3 center">
                    <h4
                      class="uppercase"
                      :class="{
                        'back-white color': !empty,
                        'back-color-3 white': empty,
                      }"
                    >
                      {{ title }}
                    </h4>
                    <small class="color underline"
                      ><br />Premi qui per vedere tutte le tue richieste
                      punti</small
                    >
                    <br />
                  </div>

                  <div class="col-md-6 col-10 mb-md-0 mb-5">
                    <vue-gauge
                      v-if="vw > 600"
                      :refid="'type-unique-id'"
                      :options="{
                        needleValue: my_registration_in_promo,
                        chartWidth: [500],
                        centralLabel: [''],
                        arcColors: [
                          '' + contests.config.COLORE_MEDIO_SCURO + '',
                          '' + contests.config.COLORE_MEDIO_CHIARO + '',
                          '' + contests.config.COLORE_SCURO + '',
                        ],
                        arcLabels: [55, 80, 100],
                        arcDelimiters: [55, 80, 99],
                        hasNeedle: [true],
                        arcOverEffect: [true],
                        needleColor: ['#f29daf'],
                      }"
                    ></vue-gauge>
                    <vue-gauge
                      v-if="vw < 600"
                      :refid="'type-unique-id'"
                      :options="{
                        needleValue: my_registration_in_promo,
                        chartWidth: [300],
                        centralLabel: [''],
                        arcColors: [
                          '' + contests.config.COLORE_MEDIO_SCURO + '',
                          '' + contests.config.COLORE_MEDIO_CHIARO + '',
                          '' + contests.config.COLORE_SCURO + '',
                        ],
                        arcLabels: [55, 80, 100],
                        arcDelimiters: [55, 80, 99],
                        hasNeedle: [true],
                        arcOverEffect: [true],
                        needleColor: ['#f29daf'],
                      }"
                    ></vue-gauge>
                    <div class="punti Bold h5 text-center">
                      <b
                        >{{ my_registration_in_promo }} punti ottenuti<br />
                        su {{ my_registration_in_promo_done }} richiesti</b
                      >
                    </div>
                  </div>
                </div>
              </template>
              <template
                slot="content"
                class="mb-4"
                v-for="(some, cod) in playContest"
              >
                <div
                  :key="cod"
                  class="row justify-content-center"
                  id="centerEl"
                >
                  <div class="col-md-12">
                    <h5
                      class="
                        widthFull
                        center
                        text-left
                        mini
                        pointer
                        cusCol
                        mb-2
                        mt-2
                        font
                        Bold
                      "
                      v-on:click="
                        selectedPlay = {};
                        selectedPlay[cod] = some;
                        secondClick(cod);
                        print(selectedPlay);
                        showShipForm = false;
                      "
                      v-scroll-to="{
                        el: '.itemReview',
                        offset: -155,
                        duration: 900,
                        force: false,
                      }"
                    >
                      <h5
                        v-if="
                          some.status == 0 ||
                          some.status == 2 ||
                          some.status == 1
                        "
                        class="color"
                      >
                        <font-awesome-icon
                          class="helper mr-1"
                          icon="info-circle"
                          size="2x"
                        />
                        Caricamento
                        <b class="black">[ N° {{ some.codicePratica }} ] </b>del
                        <span class="font">
                          {{ moment(some.playDate).format("DD-MM-YYYY") }}</span
                        >
                        <span class="font">( In corso di validazione )</span>
                        <b class="underline mt-3 mt-lg-0">mostra dettagli</b>
                      </h5>
                      <h5
                        v-if="some.status == 20 || some.status == 102"
                        class="red"
                      >
                        <font-awesome-icon
                          class="helper mr-1"
                          icon="times-circle"
                          size="2x"
                        />
                        Caricamento
                        <b class="black">[ N° {{ some.codicePratica }} ] </b>del
                        <span class="font">
                          {{ moment(some.playDate).format("DD-MM-YYYY") }}</span
                        >
                        <span v-if="some.status == 20" class="font"
                          >( Non valido )</span
                        >
                        <span v-if="some.status == 102" class="font"
                          >( Non rimborsato )</span
                        >
                        <b class="underline mt-3 mt-lg-0">mostra dettagli</b>
                      </h5>
                      <h5
                        v-if="
                          some.status == 10 ||
                          some.status == 100 ||
                          some.status == 101 ||
                          some.status == 110
                        "
                        class="green"
                      >
                        <font-awesome-icon
                          class="helper mr-1"
                          icon="check-circle"
                          size="2x"
                        />
                        Caricamento
                        <b class="black">[ N° {{ some.codicePratica }} ] </b>del
                        <span class="font">
                          {{ moment(some.playDate).format("DD-MM-YYYY") }}</span
                        >
                        <span v-if="some.status == 10" class="text-danger font"
                          >( Validato )</span
                        >
                        <span v-if="some.status == 100" class="text-danger font"
                          >( In fase di assegnazione punti )</span
                        >
                        <span v-if="some.status == 101" class="text-danger font"
                          >( Punti assegnati )</span
                        >
                        <span v-if="some.status == 110" class="text-danger font"
                          >( Rimborsato )</span
                        >
                        <b class="underline mt-3 mt-lg-0">mostra dettagli</b>
                      </h5>
                    </h5>
                  </div>
                  <div class="container-fluid">
                    <div
                      v-show="!!selectedPlay[cod]"
                      v-if="!!selectedPlay[cod]"
                      class="row mb-5 itemReview justify-content-center"
                    >
                      <div
                        v-if="selectedPlay[cod].status == 20"
                        class="col-12 center mt-2 mb-2"
                      >
                        <h5 class="Bold red">
                          Motivazione di invalidazione: <br />
                          {{ selectedPlay[cod].motivation }}
                        </h5>
                      </div>

                      <div
                        class="col-md-6 mt-5 colSxRiepilogo"
                        :style="
                          'background: ' +
                          contests.config.COLORE_CHIARO +
                          '!important'
                        "
                      >
                        <h5>
                          <p
                            class="black customHowTo"
                            :style="
                              'padding:10px;border-radius:10px;background: ' +
                              contests.config.COLORE_SCURO +
                              '!important'
                            "
                          >
                            Riepilogo dati inseriti:
                          </p>
                          <p class="black Medium">
                            <b>Totale scontrino:</b>
                            {{ selectedPlay[cod].recVal }}€
                          </p>
                          <p class="black Medium">
                            <b>Data emissione scontrino:</b>
                            {{
                              moment(selectedPlay[cod].recDate).format(
                                "DD-MM-YYYY"
                              )
                            }}
                          </p>
                          <p class="black Medium">
                            <b>Ora emissione scontrino:</b>
                            {{ selectedPlay[cod].recTime }}
                          </p>
                          <p class="black Medium">
                            <b>Data inserimento dati:</b>
                            {{
                              moment(selectedPlay[cod].playDate).format(
                                "DD-MM-YYYY"
                              )
                            }}
                          </p>
                          <p class="black Medium mb-2">
                            <b>Prodotti registrati:</b>
                          </p>
                          <table class="mt-3">
                            <thead></thead>
                            <tbody>
                              <tr>
                                <td
                                  class="bordered Bold center"
                                  :style="
                                    'background: ' +
                                    contests.config.COLORE_SCURO +
                                    '!important'
                                  "
                                >
                                  Prodotto
                                </td>
                                <td
                                  class="bordered Bold center"
                                  :style="
                                    'background: ' +
                                    contests.config.COLORE_SCURO +
                                    '!important'
                                  "
                                >
                                  Punteggio
                                </td>
                                <td
                                  class="bordered Bold center"
                                  :style="
                                    'background: ' +
                                    contests.config.COLORE_SCURO +
                                    '!important'
                                  "
                                >
                                  Quantitá
                                </td>
                              </tr>
                              <template
                                v-for="(prod, index) in JSON.parse(
                                  selectedPlay[cod].products
                                )"
                              >
                                <tr :key="index">
                                  <td class="bordered center Bold small">
                                    {{ prod.product }}
                                  </td>
                                  <td class="bordered center Bold small">
                                    {{ prod.points }}
                                  </td>
                                  <td class="bordered center Bold small">
                                    {{ prod.quantity }}
                                  </td>
                                </tr>
                              </template>
                            </tbody>
                          </table>
                        </h5>
                      </div>
                      <div
                        class="
                          col-md-5
                          center
                          ml-md-5
                          mt-md-5 mt-2 mt-md-0
                          colDxRiepilogo
                        "
                        :style="
                          'background: linear-gradient(87deg,rgba(255,255,255,1) 0%,' +
                          contests.config.COLORE_CHIARO +
                          ' 15%,' +
                          contests.config.COLORE_MEDIO_CHIARO +
                          ' 62%,' +
                          contests.config.COLORE_MEDIO_SCURO +
                          ' 100%,' +
                          contests.config.COLORE_SCURO +
                          ' 100%)'
                        "
                      >
                        <viewer
                          v-if="
                            selectedPlay[cod].receipt &&
                            !selectedPlay[cod].receipt
                              .toUpperCase()
                              .includes('.PDF')
                          "
                          class="images clearfix widthFull"
                          @inited="inited"
                        >
                          <img
                            style="border-radius: 5px !important"
                            class="img-fluid img-mod mb-5"
                            :src="selectedPlay[cod].receipt"
                          />
                        </viewer>
                        <div v-else class="mt-5 mb-5" ref="inv">
                          <small
                            :href="selectedPlay[cod].receipt"
                            target="_blank"
                            class="uppercase white btn-primary mb-5 mt-5 small"
                            style="
                              padding: 7px;
                              font-size: 14px !important;
                              border-radius: 5px !important;
                            "
                            :style="
                              'background: ' +
                              contests.config.COLORE_SCURO +
                              '!important'
                            "
                            >Clicca qui per vedere il pdf</small
                          >
                        </div>
                        <h4
                          class="Bold pt-3 pb-3 black"
                          :style="
                            'border-radius:10px;background: ' +
                            contests.config.COLORE_CHIARO +
                            '!important'
                          "
                        >
                          ID PRATICA : {{ selectedPlay[cod].codicePratica }}
                        </h4>
                        <button
                          v-if="some.status == 0 && !empty"
                          class="
                            btn btn-primary
                            uppercase
                            btn-small
                            mt-3 mt-lg-0
                          "
                          :style="
                            'background: ' +
                            contests.config.COLORE_MEDIO_SCURO +
                            '!important'
                          "
                          v-on:click="
                            disablePlay(selectedPlay[cod].codicePratica)
                          "
                        >
                          Cancella registrazione
                        </button>
                      </div>
                      <div class="col-md-12 mt-5"></div>
                    </div>
                  </div>
                </div>
              </template>
            </badger-accordion-item>
          </badger-accordion>
        </div>
        <div
          v-if="playContest != ''"
          class="row mb-5 itemReview justify-content-center"
        ></div>
        <div v-else-if="playContest == '' && loadingState" class="row">
          <div class="col center">
            <h3>Carico ....</h3>
          </div>
        </div>
        <div v-else class="row mt-5 pt-5 back-white">
          <div
            v-if="
              !empty &&
              !contest &&
              info &&
              moment(now) <= moment(end_, 'YYYY-MM-DD')
            "
            class="col center mt-5"
          >
            <h1
              class="tizaFont bbaRed Bold uppercase center widthFull mt-5 mb-5"
            >
              Non hai ancora inserito richieste punti
            </h1>
            <h3 class="mt-5"></h3>
            <a
              v-if="!contest"
              class="btn btn-primary-1 mt-5 uppercase"
              :style="
                'background: ' + contests.config.COLORE_SCURO + '!important'
              "
              v-on:click="changeView(1)"
              >Registra subito il primo scontrino</a
            >
          </div>
          <div v-else-if="!empty && !contest && info" class="col center mt-5">
            <h1
              class="tizaFont bbaRed center Bold uppercase widthFull mt-5 mb-5"
            >
              Non hai caricato richieste punti
            </h1>
            <h3 class="mt-5"></h3>
            <p
              class="btn btn-primary-1 pt-1 mt-5 uppercase"
              :style="
                'background: ' +
                contests.config.COLORE_SCURO +
                '!important;color: ' +
                contests.config.COLORE_CHIARO +
                '!important'
              "
              v-if="moment(now) < moment(start, 'YYYY-MM-DD HH:mm:ss')"
            >
              Promozione non ancora iniziata
            </p>
            <p
              class="black mt-5 h2 pt-1 pb-1 uppercase"
              :style="
                'border-radius:10px;background: ' +
                contests.config.COLORE_SCURO +
                '!important;color: ' +
                contests.config.COLORE_CHIARO +
                '!important'
              "
              v-if="moment(now) >= moment(end, 'DD-MM-YYYY')"
            >
              Promozione terminata
            </p>
          </div>
        </div>
      </div>
    </div>
    <div v-if="!info && !contest && premi" class="container">
      <div class="row justify-content-center back-white">
        <div class="col-10 pt-5 mt-2 mb-5 center"></div>
        <div class="col-12 center mb-5">
          <h5>
            “ Al termine dell’attività, in base alla soglia punti raggiunta,
            avrai diritto a un credito da spendere sul sito Mygiftcardsquare.
            Potrai scegliere tra tantissimi brand disponibili!”
          </h5>
          <a
            href="https://www.mygiftcardsquare.it/home"
            class="btn-primary-4 btn white"
             :style="
                'background: ' +
                contests.config.COLORE_MEDIO_SCURO +
                '!important;color: ' +
                contests.config.COLORE_CHIARO +
                '!important'
              "
              
            target="_blank"
          >
            <b class="white Bold">Vai al sito MygiftcardSquare</b>
          </a>
        </div>
      </div>
      <div class="row justify-content-center">
        <div class="col-12">
          <img v-if="vw>800" src="../../assets/images/premi.png" class="img img-fluid">
          <img v-else src="../../assets/images/premi-mob.png" class="img img-fluid">
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import { mapGetters, mapState } from "vuex";
import { BadgerAccordion, BadgerAccordionItem } from "vue-badger-accordion";
import axios from "axios";
import { USER_REQUEST } from "actions/user";
import Vue from "vue";
import { VueSvgGauge } from "vue-svg-gauge";
import "vue-select/dist/vue-select.css";
import "viewerjs/dist/viewer.css";
import VueGauge from "vue-gauge";

const moment = require("moment");

export default {
  name: "contest",
  components: {
    BadgerAccordion,
    BadgerAccordionItem,
    VueSvgGauge,
    VueGauge,
  },
  props: {
    pageTitle: {
      type: String,
      default: "Dashboard",
    },
  },
  data() {
    return {
      loadingState: "",
      moment: moment,
      statusPlay: {},
      contests: {},
      id: "",
      piva: "",
      title: "",
      title: "",
      contest: true,
      premi: false,
      end_rec: "",
      info: false,
      checkAccessOk: false,
      main_image: "",
      main_text: "",
      regulation: "",
      time: false,
      $viewer: "",
      vw: window.innerWidth,
      countdown: 0,
      datenow: "",
      finish: false,
      cod_client: "",
      products: [],
      products_registered: 0,
      total_product_value: 0,
      start: "",
      end: "",
      start_: "",
      end_: "",
      award_spec: "",
      id: "",
      award_image: "",
      empty: true,
      minProduct: "",
      minPrice: "",
      regex: "",
      playContest: "",
      selectedPlay: {},
      my_registration_in_promo: 0,
      my_registration_in_promo_done: 0,
      maxRegistration: 0,
      playConsens: true,
      maxRegistrationOr: 0,
      now: moment(),
      maxRegistration_: 0,
      step: require("../../assets/images/step.png"),
      doc: require("../../assets/images/doc.png"),
    };
  },
  methods: {
    setProfileData: function () {
      this.piva = this.profile.piva;
      this.email = this.profile.email;
      this.name = this.profile.ACname;
      this.lastname = this.profile.ACsecondname;
      this.userToken = this.profile.id;

      this.company = this.profile.company;
      this.phone = this.profile.phone;
      this.role = this.profile.role;
      this.iban = this.profile.iban;
      this.cod = this.profile.cod;
      this.address = this.profile.address;
      this.privacy = this.profile.consent;
      this.cod_client = this.profile.cod;

      this.group = this.profile.groupPh;
      this.profileId = this.profile.id;
    },
    checkAccess: async function () {
      if (this.piva == this.$route.params.piva) {
        this.$track("checkAccess", "START");
        var data = {
          id: this.$route.params.id,
          piva: this.$route.params.piva,
          cod: this.$route.params.cod,
          group: this.group,
          profile: this.profile,
          id_platform: process.env.ID_PLATFORM,
          unique_key_db: process.env.UNIQUE_KEY_DB,
          vector_unique_key_db: process.env.ICODE,
        };
        data = this.$encryptByAES(JSON.stringify(data), process.env.CRYPTKEY);
        await axios({
          method: "POST",
          data: { data },
          url: process.env.ROOT_API + "api/checkAccess",
          headers: {
            Authorization: "Bearer " + process.env.AUTH_TOKEN,
            "Content-type": "application/json",
          },
        })
          .then((resp) => {
            resp.data = this.$decryptByAES(resp.data, process.env.CRYPTKEY);
            this.loadingState = false;
            this.checkAccessOk = true;
            this.$track("checkAccess", "SUCCESS");
            this.$track("checkAccess", resp.data);
            if (resp.data == "access_denied") {
              this.message =
                '<b class="Bold">Non hai accesso a questa promozione</b>';
              this.UploadError("ATTENZIONE!", this.message);
            } else {
              this.loadProducts();
              this.thisPlay();
            }
          })
          .catch((err) => {
            this.loadingState = false;
            this.$track("checkAccess", "ERROR");
            err.response.data = this.$decryptByAES(
              err.response.data,
              process.env.CRYPTKEY
            );
          });
      } else {
        this.$router.push("/");
      }
    },
    myRegistration: async function () {
      if (this.piva != this.$route.params.piva) {
      } else {
        this.$track("myRegistration", "START");
        var data = {
          id: this.$route.params.id,
          piva: this.$route.params.piva,
          cod: this.$route.params.cod,
          group: this.group,
          profile: this.profile,
          promo: this.contests,
          id_platform: process.env.ID_PLATFORM,
          unique_key_db: process.env.UNIQUE_KEY_DB,
          vector_unique_key_db: process.env.ICODE,
        };
        data = this.$encryptByAES(JSON.stringify(data), process.env.CRYPTKEY);
        await axios({
          method: "POST",
          data: { data },
          url: process.env.ROOT_API + "api/myRegistration",
          headers: {
            Authorization: "Bearer " + process.env.AUTH_TOKEN,
            "Content-type": "application/json",
          },
        })
          .then((resp) => {
            resp.data = this.$decryptByAES(resp.data, process.env.CRYPTKEY);
            this.$track("myRegistration", "SUCCESS");
            this.$track("myRegistration", resp.data);
            if (resp.data) {
              this.maxRegistration =
                parseInt(resp.data[0].bonus) +
                parseInt(resp.data[0].extra_bonus);
              this.maxRegistrationOr = parseInt(resp.data[0].bonus);
            }
          })
          .catch((err) => {
            this.$track("myRegistration", "ERROR");
            err.response.data = this.$decryptByAES(
              err.response.data,
              process.env.CRYPTKEY
            );
          });
      }
    },
    thisPlay: async function () {
      if (this.$route.params.cod) {
        this.loadingState = true;
        this.$track("thisPlay", "START");
        var data = {
          id: this.$route.params.id,
          piva: this.$route.params.piva,
          cod: this.$route.params.cod,
          group: this.group,
          profile: this.profile,
          id_platform: process.env.ID_PLATFORM,
          unique_key_db: process.env.UNIQUE_KEY_DB,
          vector_unique_key_db: process.env.ICODE,
        };
        data = this.$encryptByAES(JSON.stringify(data), process.env.CRYPTKEY);
        await axios({
          method: "POST",
          data: { data },
          url: process.env.ROOT_API + "api/thisPlay",
          headers: {
            Authorization: "Bearer " + process.env.AUTH_TOKEN,
            "Content-type": "application/json",
          },
        })
          .then((resp) => {
            resp.data = this.$decryptByAES(resp.data, process.env.CRYPTKEY);
            this.$track("thisPlay", "SUCCESS");
            this.$track("thisPlay", resp.data);
            this.loadingState = false;
            if (resp.data.summary[0]) this.statusPlay = resp.data.summary[0];
            else {
              this.statusPlay = {
                TOTAL: 0,
                TO_ELABORATE: 0,
                ELABORATE_OK: 0,
                ELABORATE_KO: 0,
                ELABORATE_KO_CONFIRMED: 0,
                ELABORATE_OK_CONFIRMED: 0,
                CASHBACK_START: 0,
                CASHBACK_GONE: 0,
                CASHBACK_ERROR: 0,
                CASHBACK_SENT: 0,
                ASKED_REBATE: 0,
                RECEIVED_REBATE: 0,
                ASKED: 0,
                RECEIVED: 0,
              };
            }

            this.products_registered = resp.data.products_registered;
            this.total_product_value = resp.data.total_product_value;
          })
          .catch((err) => {
            this.loadingState = false;
            this.$track("thisPlay", "ERROR");
            err.response.data = this.$decryptByAES(
              err.response.data,
              process.env.CRYPTKEY
            );
          });
      } else {
        this.setProfileData();
      }
    },

    takeMyAttempts: async function () {
      this.loadingState = true;
      if (this.contests.config) {
        this.$track("takeMyAttempts", "START");

        var data = {
          id: this.$route.params.id,
          piva: this.$route.params.piva,
          cod: this.$route.params.cod,
          group: this.group,
          desc: this.contests.config.DESTINAZIONE_SCONTO,
          profile: this.profile,
          promo: this.contests,
          id_platform: process.env.ID_PLATFORM,
          unique_key_db: process.env.UNIQUE_KEY_DB,
          vector_unique_key_db: process.env.ICODE,
        };

        this.$track("takeMyAttempts", data);
        data = this.$encryptByAES(JSON.stringify(data), process.env.CRYPTKEY);
        await axios({
          method: "POST",
          data: { data },
          url: process.env.ROOT_API + "api/takeMyAttempts",
          headers: {
            Authorization: "Bearer " + process.env.AUTH_TOKEN,
            "Content-type": "application/json",
          },
        })
          .then((resp) => {
            this.loadingState = false;
            this.$track("takeMyAttempts", "SUCCESS");
            resp.data = this.$decryptByAES(resp.data, process.env.CRYPTKEY);
            this.$track("takeMyAttempts", resp.data);
            this.my_registration_in_promo = resp.data.OTTENUTI_PUNTI;
            this.my_registration_in_promo_done =
              resp.data.TOTALI_RICHIESTI_PUNTI;
            this.playContest = resp.data.allPlayForPromo_punti;
          })
          .catch((err) => {
            this.loadingState = false;
            this.$track("takeMyAttempts", "ERROR");
            err.response.data = this.$decryptByAES(
              err.response.data,
              process.env.CRYPTKEY
            );
          });
      } else await this.getThisContest();
    },
    disablePlay: async function (idDis) {
      this.loadingState = true;
      this.$track("disablePlay", "START");
      var data = {
        id: idDis,
        profile: this.profile,
        id_platform: process.env.ID_PLATFORM,
        unique_key_db: process.env.UNIQUE_KEY_DB,
        vector_unique_key_db: process.env.ICODE,
      };
      data = this.$encryptByAES(JSON.stringify(data), process.env.CRYPTKEY);
      await axios({
        method: "POST",
        data: { data },
        url: process.env.ROOT_API + "api/disablePlay",
        headers: {
          Authorization: "Bearer " + process.env.AUTH_TOKEN,
          "Content-type": "application/json",
        },
      })
        .then((resp) => {
          this.loadingState = false;
          this.$track("disablePlay", "SUCCESS");
          resp.data = this.$decryptByAES(resp.data, process.env.CRYPTKEY);
          this.$track("disablePlay", resp.data);
          if (resp.data)
            this.shoSuccess(
              "Pratica eliminata correttamente",
              "La pratica " + idDis + " è stata eliminata correttamente"
            );
          else this.UploadError("Errore", "Riprova piú tardi");
        })
        .catch((resp) => {
          this.$track("disablePlay", "ERROR");
          err.response.data = this.$decryptByAES(
            err.response.data,
            process.env.CRYPTKEY
          );
        });
    },
    loadProducts: async function () {
      this.loadingState = true;
      this.$track("loadProducts", "START");
      var data = {
        id: this.$route.params.id,
        id_platform: process.env.ID_PLATFORM,
        unique_key_db: process.env.UNIQUE_KEY_DB,
        vector_unique_key_db: process.env.ICODE,
      };
      data = this.$encryptByAES(JSON.stringify(data), process.env.CRYPTKEY);
      await axios({
        method: "POST",
        data: { data },
        url: process.env.ROOT_API + "api/loadProducts",
        headers: {
          Authorization: "Bearer " + process.env.AUTH_TOKEN,
          "Content-type": "application/json",
        },
      })
        .then((resp) => {
          this.$track("loadProducts", "SUECCESS");
          var prod = [];
          for (var x in resp.data) {
            var y = [];
            y["key"] = x;
            y["label"] = resp.data[x];
            prod.push(y);
          }
          this.products = prod;
          this.loadingState = false;
        })
        .catch((resp) => {
          this.loadingState = false;
          this.$track("loadProducts", "ERROR");
        });
    },

    getThisContest: async function () {
      this.loadingState = true;
      this.$track("getThisContest", "START");
      var data = {
        id: this.$route.params.id,
        status: "ACTIVE",
        id_platform: process.env.ID_PLATFORM,
        unique_key_db: process.env.UNIQUE_KEY_DB,
        vector_unique_key_db: process.env.ICODE,
      };
      data = this.$encryptByAES(JSON.stringify(data), process.env.CRYPTKEY);
      await axios({
        method: "POST",
        data: { data },
        url: process.env.ROOT_API + "api/getThisContest",
        headers: {
          Authorization: "Bearer " + process.env.AUTH_TOKEN,
          "Content-type": "application/json",
        },
      })
        .then((resp) => {
          this.loadingState = false;
          resp.data = this.$decryptByAES(resp.data, process.env.CRYPTKEY);
          this.$track("getThisContest", "SUCCESS");

          if (resp.data) this.empty = false;
          else this.getThisContestNOTACTIVE();
          for (var i in resp.data) {
            var pass = JSON.parse(resp.data[i].config);
            resp.data[i].config = pass;
          }
          if (resp.data) {
            this.contests = resp.data[0];
            this.myRegistration();
            this.takeMyAttempts();
            this.type = this.contests.config.TIPOLOGIA_RIEPILOGO;
            this.start_ = this.contests.start;
            this.startRec_ = this.contests.startRec;
            this.start_rec = moment(this.startRec_).format("DD/MM/YYYY");
            this.endRec_ = this.contests.endRec;
            this.end_rec = moment(this.endRec_).format("DD-MM-YYYY");
            this.start = moment(this.start_).format("DD-MM-YYYY");
            this.end_ = this.contests.end;
            this.end = moment(this.end_).format("DD-MM-YYYY");

            this.now = moment();
            var then = moment(this.end_);

            var dif = then.diff(this.now);
            if (dif <= 0) {
              this.finish = true;
              this.countdown = 0 - dif;
            } else {
              this.countdown = dif;
            }
            this.$track("getThisContest", this.contests);
          }
        })
        .catch((err) => {
          this.loadingState = false;
          err.response.data = this.$decryptByAES(
            err.response.data,
            process.env.CRYPTKEY
          );
          this.$track("getThisContest", "ERROR");
        });
    },
    getThisContestNOTACTIVE: async function () {
      this.loadingState = true;
      this.$track("getThisContestNOTACTIVE", "START");
      var data = {
        id: this.$route.params.id,
        status: "ENDED",
        id_platform: process.env.ID_PLATFORM,
        unique_key_db: process.env.UNIQUE_KEY_DB,
        vector_unique_key_db: process.env.ICODE,
      };
      data = this.$encryptByAES(JSON.stringify(data), process.env.CRYPTKEY);
      await axios({
        method: "POST",
        data: { data },
        url: process.env.ROOT_API + "api/getThisContest",
        headers: {
          Authorization: "Bearer " + process.env.AUTH_TOKEN,
          "Content-type": "application/json",
        },
      })
        .then((resp) => {
          this.loadingState = false;
          resp.data = this.$decryptByAES(resp.data, process.env.CRYPTKEY);
          this.$track("getThisContestNOTACTIVE", "SUCCESS");
          if (!resp.data) {
          }
          if (resp.data) {
            this.empty = false;
          }
          for (var i in resp.data) {
            var pass = JSON.parse(resp.data[i].config);
            resp.data[i].config = pass;
          }
          
          this.contests = resp.data[0];
          this.type = this.contests.config.TIPOLOGIA_RIEPILOGO;
          this.start_ = this.contests.start;
          this.start = moment(this.start_).format("DD-MM-YYYY");
          this.end_ = this.contests.end;
          this.end = moment(this.end_).format("DD-MM-YYYY");
          this.startRec_ = this.contests.startRec;
          this.start_rec = moment(this.startRec_).format("DD/MM/YYYY");
          this.endRec_ = this.contests.endRec;
          this.end_rec = moment(this.endRec_).format("DD-MM-YYYY");

          this.now = moment();
          var then = moment(this.end_);

          var dif = then.diff(this.now);
          if (dif <= 0) {
            this.finish = true;
            this.countdown = 0 - dif;
          } else {
            this.countdown = dif;
          }
          this.$track("getThisContestNOTACTIVE", this.contests);
          this.takeMyAttempts();
        })
        .catch((err) => {
          this.loadingState = false;
          err.response.data = this.$decryptByAES(
            err.response.data,
            process.env.CRYPTKEY
          );
          this.$track("getThisContestNOTACTIVE", "ERROR");
        });
    },
    inited(viewer) {
      var _vue = this;
      this.$viewer = viewer;
      setTimeout(function () {
        _vue.$viewer.zoom(1);
      }, 1000);
    },
    show() {
      var el = this.$refs.inv;
      const viewer = el.$viewer;
      viewer.show();
      viewer.zoomTo(2);
      viewer.move(-1, 0);
    },
    print(value) {},

    secondClick(id) {
      var _vue = this;
      if (_vue.activeId != "no") {
        _vue.$track("pre ID: " + id + " Active:" + _vue.activeId);

        if (id == _vue.activeId) {
          _vue.$track("same");
          var _vue = this;
          setTimeout(function () {
            _vue.$scrollTo("#centerEl", 0, { offset: -125 });
          }, 0);
          _vue.selectedPlay = {};
          _vue.activeId = "no";
        } else {
          _vue.$track("newOpen Exisrt one");
          _vue.activeId = id;
        }
      } else {
        _vue.$track("new not exist");
        _vue.activeId = id;
      }
    },

    UploadError(desc, specific) {
      this.$swal({
        type: "info",
        title: desc,
        html: specific,
        confirmButtonText: "CHIUDI",
        confirmButtonColor: "#15267",
        onClose: () => {
          this.$router.push("/");
        },
      });
    },
    shoSuccess(desc, specific) {
      this.$swal({
        type: "info",
        title: desc,
        html: specific,
        confirmButtonText: "CHIUDI",
        confirmButtonColor: "#15267",
        onClose: () => {
          window.location.reload();
        },
      });
    },
    /************************* */
    changeView(val) {
      if (val == 1) {
        this.contest = true;
        this.info = false;
        this.premi = false;
      } else if (val == 2) {
        this.contest = false;
        this.info = true;
        this.premi = false;
      } else if (val == 3) {
        this.premi = true;
        this.contest = false;
        this.info = false;
      }
    },
    toContest() {
      this.contest = true;
      this.info = false;
    },
  },
  /********************************************************************************************* */
  watch: {
    getProfile: function (val) {
      this.setProfileData();
      this.checkAccess();
    },
    "$route.params.id": {
      handler: function (id) {
        if (this.loaded) {
        }
      },
      deep: true,
      immediate: true,
    },
    "$route.params.piva": {
      handler: function (id) {
        if (this.loaded) {
        }
      },
      deep: true,
      immediate: true,
    },
    "$route.params.cod": {
      handler: function (id) {
        if (this.loaded) {
        }
      },
      deep: true,
      immediate: true,
    },
    /**************** */
    selectedPlay: function (array) {
      this.imageLoaded = true;
    },
    info: function () {
      if (this.info) {
        var _vue = this;
        setTimeout(function () {
          _vue.$refs.activeAccordion.open(0);
        }, 100);
      }
    },
    /**************** */
  },

  mounted: function () {
    this.id = this.$route.params.id;
    var piva = this.$route.params.piva;
    var cod = this.$route.params.cod;
    if (!cod) {
      this.$router.push("/");
    }
    if (!piva) {
      this.$router.push("/");
    }

    if (this.getProfile.piva) {
      this.setProfileData();
      this.checkAccess();
      this.now = moment().format("DD-MM-YYYY");
    }

    window.onresize = () => {
      this.vw = window.innerWidth;
      this.vh = window.innerHeight;
    };
    var _vue = this;
    setTimeout(function () {
      _vue.$scrollTo("#top", 0, { offset: -125 });
    }, 100);
  },
  created: async function () {
    await this.getThisContest();
  },
  computed: {
    ...mapGetters([
      "getProfile",
      "isAuthenticated",
      "isProfileLoaded",
      "acceptCookies",
    ]),
    ...mapState({
      authLoading: (state) => state.auth.status === "loading",
      profile: (state) => state.user.profile,
    }),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/contest/template_soglia_premiofisico.vue